<banner-app [Fixtop]="'fixed-top'" [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>

<div class="pt-5 py-lg-5 feedback-container">
  <div class="row justify-content-center me-0">
    <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
      <img
        class="feedback-image"
        src="./assets/img/CancelacionSeguro.png"
        width="500"
        height="320"
        priority
        alt="Ilustración de dos manos estrechándose en señal de acuerdo."
      />

      <h2 class="feedback-title mb-4">
        Estamos experimentando algunos <br />
        problemas técnicos.
      </h2>
      <p class="feedback-subtitle mb-4">Ya tenemos tus datos. Nos pondremos en contacto contigo para continuar con el proceso.</p>

      <button type="button" class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mt-lg-0 mt-3 mb-5" (click)="volverInicio()">Entendido</button>
    </div>
  </div>
</div>

<app-footer-app class="footer-fixed" />
